module.exports = __webpack_public_path__ + "img/86.162c2368.jpg";